import { all,fork } from "redux-saga/effects";

//public
import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import userSaga from "./admin/user/saga";
import rolSaga from "./roles/saga"
import accountSaga from "./account/saga"
import campaignSaga from "./campaign/saga"
import lengsSaga from "./lengs/saga"
import contactsSaga from "./contacts/saga";
import contactsDataSaga from "./contactsData/saga"
import contactsDocumentSaga from "./contactsDocument/saga"
import casosSaga from "./casos/saga";
import casosDetallesSaga from "./casosDetalles/saga";
import grupotecnicoSaga from "./grupoTecnico/saga";
import informesSaga from "./informes/saga"
import informeImageSaga from "./informeImage/saga"
import leadsSaga from "./leads/saga"
import agendaSaga from "./agenda/saga"
import comprasSaga from "./compras/saga"

export default function* rootSaga() {
  yield all([
    layoutSaga(),
    fork(authSaga),
    fork(rolSaga),
    fork(accountSaga),
    fork(campaignSaga),
    fork(lengsSaga),
    fork(userSaga),
    fork(contactsSaga),
    fork(contactsDataSaga),
    fork(contactsDocumentSaga),
    fork(grupotecnicoSaga),
    fork(casosSaga),
    fork(casosDetallesSaga),
    fork(informesSaga),
    fork(informeImageSaga),
    fork(leadsSaga),
    fork(agendaSaga),
    fork(comprasSaga),
  ]);
}
